import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DragOverlay } from '@dnd-kit/core';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { DraggingBombDisplay } from './panels/bombsPanel/draggingBombDisplay';
export const DragOverlayItem = () => {
    const draggingBomb = useAppSelector((state) => state.bombs.draggingBomb, shallowEqual);
    return (_jsx(DragOverlay, { dropAnimation: null, children: draggingBomb ? (_jsx(DraggingBombDisplay, { bombType: draggingBomb.type, isOverTarget: draggingBomb.isOverTarget })) : null }));
};
